import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

// Self-hosted Plus Jakarta Sans (variable), so weight changes cost no extra file.
import '@fontsource-variable/plus-jakarta-sans'

// Order matters: tokens define the variables the other sheets consume.
import '@/styles/tokens.css'
import '@/styles/reset.css'
import '@/styles/effects.css'
import '@/styles/global.css'

import { App } from '@/app/App'

const container = document.getElementById('root')
if (!container) {
  throw new Error('Root element #root is missing from index.html')
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
